import { QueryKeys, useCustomQuery } from '.';

export const useQueryCommonDataModels = ({ params, enabled }) =>
  useCustomQuery([QueryKeys.CommonDataModels.CommonDataModels, params], {
    url: `/api/shared/common-data-models/${params.taxYear}/${params.jurisdictionId}`,
    enabled,
    defaultData: [],
    errorMessage: 'Error fetching common data models',
  });
